import { render } from "./TariffDetailTab.vue?vue&type=template&id=3cbbdf1e"
import script from "./TariffDetailTab.vue?vue&type=script&lang=js"
export * from "./TariffDetailTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__